module.exports = __webpack_public_path__ + "img/banner_mobile@2x.d664e938.jpg";